import { SELECTORS } from '../const.js';
import PopupComponent from './popup.js';
import { render, RenderPosition, replace } from '../utils/render.js';
import { Keys } from '../const.js';
import { getRandomIntegerNumber } from '../utils/common.js';

export default class WheelFortune {
  constructor(siteBodyElement) {
    this._siteBodyElement = siteBodyElement;
    this._spinnerBodyElement = this._siteBodyElement.querySelector(`.spinner`);
    this._spinnerWheel = this._spinnerBodyElement.querySelector(
      `.wheel-fortune__images`
    );
    this._wheelFortuneCatalogPopup = this._spinnerBodyElement.querySelector(
      `.wheel-fortune__catalog-popup`
    );
    this._startButton = this._siteBodyElement.querySelector(`.spinner__button`);
    this._infoBlock = this._siteBodyElement.querySelector(`.info-block`);
    this._infoBlockBody =
      this._siteBodyElement.querySelector(`.info-block__body`);
    this.state = {
      areaCatalogButtonActivate: false,
      actualDeg: 0,
      deg: 0,
      filterItem: ``,
      indexType: 0,
      n: 13,
      randomSector: 0,
      selectedSector: ``,
      wheelButtonActivate: false,
    };

    this._startSpinnerWheel = this._startSpinnerWheel.bind(this);
    this._stopSpinnerWheel = this._stopSpinnerWheel.bind(this);

    this._popupComponent = null;
    this._handleClosePopup = this._handleClosePopup.bind(this);
    this._escKeyDownHandler = this._escKeyDownHandler.bind(this);
  }

  init() {
    this._startButton.addEventListener(`click`, this._startSpinnerWheel);
    this._spinnerWheel.addEventListener(
      `transitionend`,
      this._stopSpinnerWheel
    );
  }

  showSliderPopup() {
    this._popupComponent = new PopupComponent(
      this._siteBodyElement,
      this.state.filterItem,
      this.state.selectedSector
    );
    this._popupComponent.setClosePopupHandler(this._handleClosePopup);
    document.addEventListener(`keydown`, this._escKeyDownHandler);
    if (this._siteBodyElement.querySelector('.slider')) {
      this._siteBodyElement.querySelector('.slider').remove();
    }
    this._infoBlock.style.display = `block`;
    render(
      this._infoBlockBody,
      this._popupComponent,
      RenderPosition.BEFOREBEGIN
    );
    this._startButton.querySelector('span').innerHTML = 'Крутить еще раз';
    if (window.screen.width < 1023) {
      window.scrollTo({
        top: window.screen.height,
        behavior: 'smooth',
      });
      this._siteBodyElement
        .querySelector('.slider__up-icon')
        .addEventListener('click', function () {
          window.scrollTo({
            top: window.screen.height * -1,
            behavior: 'smooth',
          });
        });
    }
    this._infoBlockBody.style.display = `none`;
  }

  _escKeyDownHandler(event) {
    if (event.key === Keys.ESC || event.key === Keys.ESCAPE) {
      event.preventDefault();
      this._removeDetailsPopup();
    }
  }

  _removeDetailsPopup() {
    this._popupComponent.getElement().remove();
    document.removeEventListener(`keydown`, this._escKeyDownHandler);
  }

  _handleClosePopup() {
    this._removeDetailsPopup();
  }

  _startSpinnerWheel() {
    'ga' in window && ga('send', 'event', 'SpecialProject', '23feb21_roll');
    this._startButton.style.pointerEvents = `none`;
    this._getRandomSector();

    this._spinnerWheel.style.transition = `all 5s ease-out`;
    // this._spinnerWheel.style.transition = `all 0.1s ease-out`;
    this._spinnerWheel.style.transform = `rotate(${this.state.deg}deg)`;
    this._spinnerWheel.classList.add(`blur`);
  }

  _stopSpinnerWheel(event) {
    this._spinnerWheel.classList.remove(`blur`);
    this._startButton.style.pointerEvents = `auto`;
    this._spinnerWheel.style.transition = `none`;
    this._spinnerWheel.style.transform = `rotate(${this.state.actualDeg}deg)`;
    setTimeout(() => {
      this.showSliderPopup();
    }, 100);
  }

  _getRandomSector() {
    let numberSector;

    let summCoefficientWeight = SELECTORS.reduce((result, { weight }) => {
      result = result + weight;
      return result;
    }, 0);

    numberSector = getRandomIntegerNumber(0, summCoefficientWeight - 1);

    for (let i = 0; i <= SELECTORS.length; i++) {
      if (numberSector < SELECTORS[i].weight) {
        this.state.randomSector = [i];
        this.state.selectedSector = SELECTORS[i].type;
        break;
      } else {
        numberSector = numberSector - SELECTORS[i].weight;
      }
    }

    this.state.actualDeg =
      (1 / 16 + this.state.randomSector * (1 / 8)) * 360;

    this.state.deg = this.state.actualDeg + 360 * this.state.n;
  }
}
